import Vue from 'vue'

import Select from '@/components/base/select2/Select.vue'
import Option from '@/components/base/select2/Option'

Vue.component('select2', Select)
Vue.component('option2', Option)
